import { useEffect } from "react";

import styled from "styled-components";

import Sidebar from "../../components/sidebar/sidebar";

const PageContentSection = styled.div`
  overflow-y: auto;
  flex-grow: 2;
  padding: 4rem 3rem;
  &::-webkit-scrollbar {
    width: 2px;
  }
  @media (max-width: 1090px) {
    padding: 1rem 1rem;
  }
  /* backdrop beside the menu: tapping it closes the menu */
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
`;
const LayoutWrapper = styled.section`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    position: fixed;
    /* above page content (cards use z-index 1-2), below bootstrap modals (1050+) */
    z-index: 1040;
  }
`;
const NavbarSection = styled.div`
  width: 346px;
  height: 100vh;
  background: #ffffff;
  border-radius: 0px 10px 10px 0px;
`;
export default function Menus({ children, onClose }) {
  useEffect(() => {
    document.body.classList.add("bg-body-cover");
  }, []);
  return (
    <LayoutWrapper>
      <NavbarSection>
        <Sidebar />
      </NavbarSection>
      <PageContentSection onClick={onClose}>{children}</PageContentSection>
    </LayoutWrapper>
  );
}
